import React, { useState } from 'react';
import MemberCard from '../components/MemberCard';
import { useAdminAuth } from '../../../context/AdminAuthContext';

const Members = () => {
    const { isAdmin } = useAdminAuth();
    const [showModal, setShowModal] = useState(false);
    const [showConfirmCloseModal, setShowConfirmCloseModal] = useState(false);

    const handleCreateNew = () => {
        setShowModal(true);
    };

    const handleSaveModal = async () => {
        const formData = new FormData();
        const name = document.getElementById('name').value;
        const surname = document.getElementById('surname').value;
        const role = document.getElementById('role').value;
        const bio = document.getElementById('bio').value;
        const scholar = document.getElementById('scholar').value;
        const orcid = document.getElementById('orcid').value;
        const prisma = document.getElementById('prisma').value;
        const imgFile = document.getElementById('img_url').files[0];
        const imgAlt = document.getElementById('img_alt').value;

        formData.append('name', name);
        formData.append('surname', surname);
        formData.append('role', role);
        formData.append('bio', bio);
        formData.append('scholar', scholar);
        formData.append('orcid', orcid);
        formData.append('prisma', prisma);
        formData.append('img_alt', imgAlt);

        if (imgFile) {
            formData.append('img_url', imgFile);
        }

        try {
            const response = await fetch('https://grupo.us.es/ligaincom/api/member_func.php', {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Error al guardar el integrante');
            }

            const result = await response.json();
            if (result.success) {
                alert('Integrante guardado con éxito');
            } else {
                alert('Error al guardar el integrante: ' + result.message);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setShowModal(false);
        }
        window.location.reload();
    };

    const handleCloseModal = () => {
        setShowConfirmCloseModal(true);
    };

    const handleConfirmClose = () => { // Seguridad para no perder datos
        setShowModal(false);
        setShowConfirmCloseModal(false);
    };

    const handleCancelClose = () => {
        setShowConfirmCloseModal(false);
    };

    return (
        <div>
            <h2 className = "title">Integrantes</h2>
            <hr className="small-hr"></hr><br />
            {isAdmin && (
                <>
                    <button onClick={handleCreateNew} 
                        style={{ marginBottom: '20px', marginLeft: '45%', padding: '10px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px' }}>
                        Crear nuevo integrante
                    </button>

                    {showModal && (
                        <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Crear nuevo integrante</h5>
                                        <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseModal}></button>
                                    </div>
                                    <div className="modal-body">
                                        <form>
                                            <label htmlFor="name">Nombre:</label>
                                            <input type="text" id="name" name="name" /><br />
                                            <label htmlFor="surname">Apellidos:</label>
                                            <input type="text" id="surname" name="surname" /><br />
                                            <label htmlFor="role">Rol:</label>
                                            <input type="text" id="role" name="role" /><br />
                                            <label htmlFor="bio">Bio:</label>
                                            <small className="text-muted"> Recomendable no más de 1000 caracteres </small><br />
                                            <textarea rows="8" cols="35" id="bio" name="bio"></textarea><br />
                                            <label htmlFor="scholar">Dirección de Google Scholar:</label>
                                            <input type="text" id="scholar" name="scholar" /><br />
                                            <label htmlFor="orcid">Dirección de Orcid:</label>
                                            <input type="text" id="orcid" name="orcid" /><br />
                                            <label htmlFor="prisma">Dirección de Prisma:</label>
                                            <input type="text" id="prisma" name="prisma" /><br /><br />
                                            <label htmlFor="img_url">Imagen:</label>
                                            <input type="file" id="img_url" name="img_url" accept="image/*" /><br /><br />
                                            <label htmlFor="img_alt">Texto alternativo de la imagen:</label><small className="text-muted"> Necesario para personas con discapacidad visual</small><br />
                                            <input type="text" id="img_alt" name="img_alt"/><br />
                                        </form> 
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Cancelar</button>
                                        <button type="button" className="btn btn-primary" onClick={handleSaveModal}>Guardar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {showConfirmCloseModal && (
                        <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Confirmar cierre</h5>
                                        <button type="button" className="btn-close" aria-label="Close" onClick={handleCancelClose}></button>
                                    </div>
                                    <div className="modal-body">
                                        <p>¿Quieres abandonar la creación? Se perderán los cambios no guardados.</p>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={handleCancelClose}>Volver</button>
                                        <button type="button" className="btn btn-primary" onClick={handleConfirmClose}>Salir</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
            <MemberCard isAdmin={isAdmin} />
        </div>
    );
};

export default Members ;
